import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  zh: {
    translation: {
      app: { title: '学术文献综述系统', subtitle: '知识图谱驱动的多智能体综述生成平台' },
      nav: { newRun: '新建任务', history: '历史记录', settings: '设置' },
      run: { status: '状态', progress: '进度', duration: '耗时', stages: '阶段' },
      search: { title: '文献搜索', query: '搜索查询', sources: '数据源', total: '共搜索到', papers: '篇论文' },
      cluster: { title: '聚类分析', clusters: '个簇', noise: '噪声点', terms: '关键词' },
      kg: { title: '知识图谱', entities: '实体', relations: '关系' },
      review: { title: '学术综述', sections: '章节', citations: '引用', total: '总计', words: '字数', verified: '已验证', references: '参考文献', noContent: '暂无综述内容', downloadMarkdown: '下载 Markdown', failedToLoad: '加载失败', viewReview: '查看综述', close: '关闭' },
      config: { topic: '研究主题', topicPH: '请输入研究主题...', sources: '数据源', style: '引用格式', yearRange: '年份范围', yearFrom: '起始年份', yearTo: '结束年份', launch: '启动分析', launching: '启动中...', outputFormats: '输出格式' },
      download: { download: '下载', ready: '就绪', generating: '生成中' },
      usage: { title: '本次消耗', duration: '总耗时', wallTime: '任务 wall time', cpu: 'CPU', memory: '内存', noData: '暂无消耗数据' },
      status: { queued: '排队中', running: '运行中', completed: '已完成', failed: '失败', interrupted: '已中断' },
      error: { title: '错误信息', noError: '无错误', warning: '警告' },
    }
  },
  en: {
    translation: {
      app: { title: 'Academic Review Studio', subtitle: 'KG-Driven Multi-Agent Review Generation Platform' },
      nav: { newRun: 'New Run', history: 'History', settings: 'Settings' },
      run: { status: 'Status', progress: 'Progress', duration: 'Duration', stages: 'Stages' },
      search: { title: 'Paper Search', query: 'Search Query', sources: 'Sources', total: 'Total', papers: 'papers' },
      cluster: { title: 'Cluster Analysis', clusters: 'clusters', noise: 'noise', terms: 'Keywords' },
      kg: { title: 'Knowledge Graph', entities: 'Entities', relations: 'Relations' },
      review: { title: 'Review Generation', sections: 'Sections', citations: 'Citations', total: 'Total', words: 'Words', verified: 'Verified', references: 'References', noContent: 'No review content available.', downloadMarkdown: 'Download Markdown', failedToLoad: 'Failed to load', viewReview: 'View Review', close: 'Close' },
      config: { topic: 'Research Topic', topicPH: 'Enter research topic...', sources: 'Sources', style: 'Citation Style', yearRange: 'Year Range', yearFrom: 'Year from', yearTo: 'Year to', launch: 'Launch Review', launching: 'Launching...', outputFormats: 'Output Formats' },
      download: { download: 'Download', ready: 'Ready', generating: 'Generating' },
      usage: { title: 'Run Usage', duration: 'Total Duration', wallTime: 'Task wall time', cpu: 'CPU', memory: 'Memory', noData: 'No usage data yet' },
      status: { queued: 'Queued', running: 'Running', completed: 'Completed', failed: 'Failed', interrupted: 'Interrupted' },
      error: { title: 'Errors', noError: 'No errors', warning: 'Warning' },
    }
  }
};

i18n.use(initReactI18next).init({
  resources, lng: 'zh', fallbackLng: 'zh',
  interpolation: { escapeValue: false },
});

export default i18n;
